import { State } from 'country-state-city';
export const getStatesInUSA = () => {

    const res = State.getStatesOfCountry('US');
    console.log(res);
    return res;
}